<template>
    <div>
        <DataTable
            searchable
            :endpoint="
                route('api.admin.audits', {
                    model: model,
                    id: modelId,
                })
            "
            :columns="[
                { title: 'Date', field: 'date' },
                { title: 'Event', field: 'event' },
                { title: 'User', field: 'user' },
                { title: 'Changes', field: 'changes' },
            ]"
        >
            <template #column(date)="{ row }">
                {{ DateTime.fromISO(row.created_at).toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS) }}
            </template>
            <template #column(user)="{ row }">
                <span v-if="!row.user" class="text-muted">System</span>
                <User v-else :user="row.user" :hide-name="false" />
            </template>
            <template #column(changes)="{ row }">
                <pre
                    class="tw-m-0 tw-max-w-[40rem] tw-overflow-x-auto tw-whitespace-pre-wrap tw-break-words tw-rounded tw-bg-slate-50 tw-p-2 tw-text-xs tw-leading-5"
                ><span
                    v-for="(part, index) in auditDiff(row)"
                    :key="index"
                    :class="{
                        'tw-bg-green-100 tw-text-green-800': part.added,
                        'tw-bg-red-100 tw-text-red-800': part.removed,
                        'tw-text-slate-500': !part.added && !part.removed,
                    }"
                >{{ part.value }}</span></pre>
            </template>
        </DataTable>
    </div>
</template>
<script setup>
import User from '@/js/components/widgets/User.vue';
import DataTable from '@/js/components/tables/DataTable.vue';
import { DateTime } from 'luxon';
import { diffJson } from 'diff';

defineProps({
    model: {
        type: String,
    },
    modelId: {
        type: [String, Number],
    },
});

const normaliseAuditValue = (value) => {
    if (typeof value !== 'string') {
        return value ?? {};
    }

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};

const auditDiff = (audit) => {
    return diffJson(normaliseAuditValue(audit.old_values), normaliseAuditValue(audit.new_values));
};
</script>
